<template>
	<v-list>
		<v-list-item-group v-model="selectedItem">
			<v-list-item
				v-for="item in items"
				:key="item.id"
				@click="$emit('click', item)"
			>
				<v-list-item-title v-text="item[itemText]" />
				<v-list-item-action>
					<menu-default
						icon="fas fa-ellipsis-v"
						:items="
							options.map((op) => ({ ...op, action: () => op.action(item) }))
						"
						:menu="menuProps"
					></menu-default>
				</v-list-item-action>
			</v-list-item>
		</v-list-item-group>
	</v-list>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			required: true,
		},
		itemText: String,
		options: Array,
	},

	data() {
		return {
			selectedItem: null,
			menuProps: {
				bottom: true,
				left: true,
				dense: true,
			},
		};
	},

	watch: {
		selectedItem(index) {
			this.$emit("change", this.items[index] || null);
		},
	},
};
</script>
